module.exports = __webpack_public_path__ + "img/edit-case-information.e01fa3f6.svg";